import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ResumeUpload from './ResumeUpload';
import ParsedDataReview from './ParsedDataReview';

type FlowState = 'upload' | 'review';

const UploadFlow: React.FC = () => {
  const navigate = useNavigate();
  const [flowState, setFlowState] = useState<FlowState>('upload');
  const [parsedData, setParsedData] = useState<any>(null);

  const handleUploadComplete = (data: any) => {
    console.log('Upload complete, parsed data:', data);
    setParsedData(data);
    setFlowState('review');
  };

  const handleSkip = () => {
    // Navigate to traditional voice-only journey creation
    navigate('/new-journey');
  };

  const handleBack = () => {
    setParsedData(null);
    setFlowState('upload');
  };

  return (
    <>
      {flowState === 'upload' && (
        <ResumeUpload 
          onUploadComplete={handleUploadComplete}
          onSkip={handleSkip}
        />
      )}
      {flowState === 'review' && parsedData && (
        <ParsedDataReview 
          data={parsedData}
          onBack={handleBack}
        />
      )}
    </>
  );
};

export default UploadFlow;

